import CommonForm, { FormFieldConfig } from "Components/Common/CommonForm";
import React, { useEffect } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { Button, Spinner, Modal, ModalHeader, ModalBody } from "reactstrap";
import { validations } from "validations/FormValidations";
import { userFields } from "../helpers/userconstant";

interface AddUserModalProps {
  isOpen: boolean;
  toggle: () => void;
  onSave: (data: any) => void;
  loading?: boolean;
  mode?: "add" | "edit";
  existingData?: any;
}

const AddUserModal: React.FC<AddUserModalProps> = ({
  isOpen,
  toggle,
  onSave,
  loading = false,
  mode = "add",
  existingData,
}) => {
  const {
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    getValues,
    formState: { errors, isSubmitting },
  } = useForm<any>({
    mode: "onChange",
    defaultValues: {
      username: "",
      firstname: "",
      lastname: "",
      useremail: "",
      userpassword: "",
      confirmpassword: "",
      contactnumber: "",
    },
  });

  useEffect(() => {
    if (isOpen) {
      if (mode === "edit" && existingData) {
        reset({
          username: existingData.username || "",
          firstname: existingData.firstname || "",
          lastname: existingData.lastname || "",
          useremail: existingData.useremail || "",
          userpassword: "",
          confirmpassword: "",
          contactnumber: existingData.contactnumber || "",
        });
      } else {
        reset({
          username: "",
          firstname: "",
          lastname: "",
          useremail: "",
          userpassword: "",
          confirmpassword: "",
          contactnumber: "",
        });
      }
    }
  }, [isOpen, mode, existingData, reset]);


const fields = React.useMemo(() => {
  const baseFields = [...userFields];

  if (mode !== "edit") {
    baseFields.push(
      {
        name: "userpassword",
        label: "Password",
        type: "password",
        placeholder: "Enter password",
        required: true,
        rules: validations.user.password,
      },
      {
        name: "confirmpassword",
        label: "Confirm Password",
        type: "password",
        placeholder: "Confirm password",
        required: true,
        rules: {
          required: "Confirm password is required",
          validate: (val: string) =>
            watch("userpassword") === val || "Passwords do not match",
        },
      }
    );
  }

  return baseFields;
}, [mode, watch]);

  const onSubmit: SubmitHandler<any> = (data) => {
    // Exclude confirmpassword from backend payload
    const { confirmpassword, ...payload } = data;
    onSave(payload);
  };

  const handleToggle = () => {
    reset();
    toggle();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleToggle}
      size="lg"
      backdrop="static"
      centered
      className="common_modal"
    >
      <ModalHeader toggle={handleToggle} className="border-bottom p-3">
        {mode === "edit" ? "Edit User" : "Add User"}
      </ModalHeader>

      <ModalBody>
        <form onSubmit={handleSubmit(onSubmit)}>
          <CommonForm
            columns={2}
            control={control}
            errors={errors as any}
            fields={fields}
            setValue={setValue}
            getValues={getValues}
          />

          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button color="dark" outline onClick={handleToggle}>
              Cancel
            </Button>

            <Button
              color="primary"
              outline
              disabled={loading || isSubmitting}
              type="submit"
            >
              {(loading || isSubmitting) && (
                <Spinner size="sm" className="me-2" />
              )}
              Save
            </Button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default AddUserModal;
